import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "data-item" };
const _hoisted_2 = { class: "data-item__header" };
const _hoisted_3 = { class: "data-item__topic" };
const _hoisted_4 = { class: "data-item__title" };
const _hoisted_5 = { class: "data-item__actions" };
const _hoisted_6 = { class: "data-item__content" };
const _hoisted_7 = {
    key: 0,
    class: "data-item__section"
};
const _hoisted_8 = { class: "data-item__section-title" };
const _hoisted_9 = { class: "data-item__section-title" };
const _hoisted_10 = { class: "data-item__section-title" };
const _hoisted_11 = { class: "data-item__section-title" };
const _hoisted_12 = { class: "form__buttons" };
const _hoisted_13 = {
    type: "submit",
    class: "button button--primary"
};
import { onMounted, ref } from 'vue';
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import exportProfileRepository from "../services/ShopExportProfileRepository";
import trans from '@astina/paloma-common-ui/src/services/Translator';
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import { clone } from 'lodash';
import { saveShopExportProfile } from "../commands/SaveShopExportProfile";
import { useRoute, useRouter } from "vue-router";
import RouterUtils from "@astina/paloma-common-ui/src/util/RouterUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ExportProfileEditView',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const form = createFormConfig();
        const profile = ref(null);
        const draft = ref(null);
        const validation = ref({ errors: [], fields: {} });
        const source = ref(null);
        const transport = ref(null);
        const converter = ref(null);
        onMounted(() => {
            loadProfile()
                .then(() => draft.value = clone(profile.value))
                .then(() => loadSource())
                .then(() => loadConverter())
                .then(() => loadTransport());
        });
        function saveExportProfile() {
            saveShopExportProfile(draft.value)
                .then(profile => profile.value = profile)
                .then(() => {
                router.push({ name: 'integration_export_details', params: { id: profile.value?.id } });
            })
                .catch((v) => {
                validation.value = v;
            });
        }
        function loadProfile() {
            const id = RouterUtils.singleParam(route, 'id');
            return exportProfileRepository
                .get(id)
                .then(p => {
                profile.value = p;
            });
        }
        function loadSource() {
            exportProfileRepository.getSource(profile.value.source)
                .then(s => {
                source.value = s;
            });
        }
        function loadTransport() {
            exportProfileRepository.getTransport(profile.value.transport)
                .then(t => {
                transport.value = t;
            });
        }
        function createFormConfig() {
            return {
                name: 'export_profile',
                fields: [
                    {
                        name: 'name',
                        label: trans('export_profile.name'),
                        type: 'text',
                        options: {
                            required: true,
                            maxLength: 255,
                        }
                    },
                    {
                        name: 'status',
                        label: trans('export_profile.status'),
                        type: 'choice',
                        options: {
                            required: true,
                            expanded: true,
                            choices: [
                                {
                                    value: 'active',
                                    label: trans('export_profile.status_active'),
                                },
                                {
                                    value: 'inactive',
                                    label: trans('export_profile.status_inactive'),
                                },
                            ]
                        }
                    },
                    {
                        name: 'schedule',
                        label: trans('export_profile.schedule'),
                        type: 'text',
                        options: {
                            help: 'CRON expression: SEC MIN HOUR DAY MONTH WEEKDAY',
                            required: true,
                            maxLength: 20,
                        },
                    },
                    {
                        name: 'scheduleZoneId',
                        label: trans('export_profile.schedule_timezone'),
                        type: 'text',
                        options: {
                            help: trans('export_profile.schedule_timezone_help'),
                            maxLength: 30,
                        },
                    },
                ],
            };
        }
        function loadConverter() {
            exportProfileRepository.getConverter(profile.value.format)
                .then(c => {
                converter.value = c;
            });
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_form_fields = _resolveComponent("form-fields");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    (profile.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('export_profile.edit')), 1),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            _createElementVNode("h1", _hoisted_4, _toDisplayString(profile.value.name), 1),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_router_link, {
                                    to: { name: 'integration_export_details', params: { id: profile.value.id } },
                                    class: "button button--outline"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                                    ]),
                                    _: 1
                                }, 8, ["to"])
                            ])
                        ], 64))
                        : (_openBlock(), _createBlock(Spinner, {
                            key: 1,
                            loading: !profile.value
                        }, null, 8, ["loading"]))
                ]),
                _cache[11] || (_cache[11] = _createTextVNode()),
                _createElementVNode("div", _hoisted_6, [
                    (draft.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("form", {
                                onSubmit: _withModifiers(saveExportProfile, ["prevent"]),
                                class: "form form--simple",
                                novalidate: ""
                            }, [
                                _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('export_profile.general_settings')), 1),
                                _cache[6] || (_cache[6] = _createTextVNode()),
                                _createVNode(_component_form_fields, {
                                    form: _unref(form),
                                    fields: _unref(form).fields,
                                    data: draft.value,
                                    validation: validation.value
                                }, null, 8, ["form", "fields", "data", "validation"]),
                                _cache[7] || (_cache[7] = _createTextVNode()),
                                (source.value && source.value.form.fields.length > 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t('export_profile.source_settings')), 1),
                                        _cache[2] || (_cache[2] = _createTextVNode()),
                                        _createVNode(_component_form_fields, {
                                            form: source.value.form,
                                            fields: source.value.form.fields,
                                            data: draft.value.sourceSettings,
                                            validation: validation.value
                                        }, null, 8, ["form", "fields", "data", "validation"])
                                    ], 64))
                                    : _createCommentVNode("", true),
                                _cache[8] || (_cache[8] = _createTextVNode()),
                                (converter.value && converter.value.form.fields.length > 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.$t('export_profile.format_settings')), 1),
                                        _cache[3] || (_cache[3] = _createTextVNode()),
                                        _createVNode(_component_form_fields, {
                                            form: converter.value.form,
                                            fields: converter.value.form.fields,
                                            data: draft.value.formatSettings,
                                            validation: validation.value
                                        }, null, 8, ["form", "fields", "data", "validation"])
                                    ], 64))
                                    : _createCommentVNode("", true),
                                _cache[9] || (_cache[9] = _createTextVNode()),
                                (transport.value && transport.value.form.fields.length > 0)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t('export_profile.transfer_settings')), 1),
                                        _cache[4] || (_cache[4] = _createTextVNode()),
                                        _createVNode(_component_form_fields, {
                                            form: transport.value.form,
                                            fields: transport.value.form.fields,
                                            data: draft.value.transportSettings,
                                            validation: validation.value
                                        }, null, 8, ["form", "fields", "data", "validation"])
                                    ], 64))
                                    : _createCommentVNode("", true),
                                _cache[10] || (_cache[10] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("button", _hoisted_13, [
                                        _createVNode(Icon, { name: "save" }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('save')), 1)
                                    ]),
                                    _cache[5] || (_cache[5] = _createTextVNode()),
                                    _createVNode(_component_router_link, {
                                        to: { name: 'integration_export_details', params: { id: profile.value?.id } },
                                        class: "button button--link button--cancel"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["to"])
                                ])
                            ], 32)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
